import __request__ from "routing/request";
export function renderHtml(type, JSONbody) {
  return __request__("POST", `/system/notification/message/html/${type}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function renderHtmlWithKey(type, key, JSONbody) {
  return __request__("POST", `/system/notification/message/html/${type}/${key}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function renderPlainText(type, JSONbody) {
  return __request__("POST", `/system/notification/message/plaintext/${type}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function renderPlainTextWithKey(type, key, JSONbody) {
  return __request__("POST", `/system/notification/message/plaintext/${type}/${key}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
